/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityDiscountReportCreatePage = lazyLoad(
  () => import('./index'),
  module => module.EntityDiscountReportCreatePage
);
